"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktDashboardTauxFixeTable", {
  bindings: {},
  template: require("./mktDashboardTauxFixeTable.html"),
  controller: function controller($http, $translate) {
    var ctrl = this;
    ctrl.state = {
      typeAmortissement: "LINEAIRE",
      periodicite: "SEMESTRIELLE"
    };
    ctrl.periodicites = [{
      id: 'MENSUELLE',
      name: $translate('lov.periodicites.MENSUELLE')
    }, {
      id: 'TRIMESTRIELLE',
      name: $translate('lov.periodicites.TRIMESTRIELLE')
    }, {
      id: 'SEMESTRIELLE',
      name: $translate('lov.periodicites.SEMESTRIELLE')
    }, {
      id: 'ANNUELLE',
      name: $translate('lov.periodicites.ANNUELLE')
    }];
    ctrl.typeAmortissements = [{
      id: 'LINEAIRE',
      name: $translate('lov.typesAmortissement.LINEAIRE')
    }, {
      id: 'CONSTANT',
      name: $translate('lov.typesAmortissement.CONSTANT')
    }, {
      id: 'IN_FINE',
      name: $translate('lov.typesAmortissement.IN_FINE')
    }];
    ctrl.$onInit = function () {
      loadTableData();
    };
    ctrl.onChange = function () {
      loadTableData();
    };
    function loadTableData() {
      ctrl.loading = true;
      var params = {
        typeAmortissement: ctrl.state.typeAmortissement,
        periodicite: ctrl.state.periodicite
      };
      $http.get("/rest/market/dashboard/taux-fixe-summary", {
        params: params
      }).then(function (response) {
        ctrl.tableData = response.data;
      }).finally(function () {
        ctrl.loading = false;
      });
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mktDashboardTauxFixeTable.js
// module id = 2844
// module chunks = 13